import { render, staticRenderFns } from "./THGHeader.vue?vue&type=template&id=295e0932&scoped=true"
import script from "./THGHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./THGHeader.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./THGHeader.vue?vue&type=style&index=0&id=295e0932&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295e0932",
  null
  
)

export default component.exports